import React from 'react';
import moment from 'moment';

export default class ArticlePreviewBSMais extends React.Component {

    obtemTipoBadge(tipo) {

        let _tipoBadge;
        let _textColorInside = 'white';
        let _textColorOutside;

        switch (tipo.toLowerCase()) {
            case "bd":
                _tipoBadge = 'water';
                _textColorOutside = _tipoBadge;
                break;
            case "bm":
                _tipoBadge = 'info';
                _textColorOutside = _tipoBadge;
                break;
            case "tc":
                _tipoBadge = 'danger';
                _textColorOutside = _tipoBadge;
                break;
            case "rd":
                _tipoBadge = 'warning';
                _textColorOutside = 'secondary';
                _textColorInside = 'secondary';
                break;
            case "bj":
                _tipoBadge = 'success';
                _textColorOutside = _tipoBadge;
                break;
            case "da":
                _tipoBadge = 'secondary';
                _textColorOutside = _tipoBadge;
                break;
            default:
                _tipoBadge = 'primary';
                _textColorOutside = _tipoBadge;
                break;
        }

        return {
            textColorOutside: `${_textColorOutside}`,
            textColorInside: `${_textColorInside}`,
            badgeColor: `${_tipoBadge}`,
            btnOutColor: `${_tipoBadge}`,
        }
    }


    render() {

        const { imagem, flagCancelado, dtPublicacao, nomeSecao, autor, titulo, previaDescricao, previaTexto, sigla } = this.props;
        return (
            <div className={`col-12 px-0 d-flex justify-content-center div-preview-bs-mais`}>
                <div className={`preview-container bg-white`}>
                    <div className="preview-content border">
                        <div className="row no-gutters">
                            <div className="col-12 preview-text">
                                <div className='row no-gutters'>
                                    <div className='col-12 cabecalho'>
                                        <div className="row no-gutters secao pt-3 mx-2 text-center border-bottom">
                                            <div className='col-12 text-center'>
                                                <p className={`text-${this.obtemTipoBadge(sigla).badgeColor}`}>{nomeSecao.toUpperCase()}</p>
                                            </div>
                                        </div>
                                        <p className="my-2 titulo text-center">{titulo}</p>
                                        {!!previaDescricao && (
                                            <strong><i><p className="my-2 descricao text-center">{previaDescricao}</p></i></strong>
                                        )}
                                        <div className='row no-gutters data-autor'>
                                            <div className='col-7'>
                                                <p className="m-0">
                                                    <small>
                                                        {(dtPublicacao && !flagCancelado) ? moment(dtPublicacao).format(
                                                            'DD [de] MMMM [de] YYYY'
                                                        ) : '[Data]'}
                                                    </small>
                                                </p>
                                                {!!autor && (
                                                    <p className="m-0"><small>Autor: <strong>{autor}</strong></small></p>
                                                )}
                                            </div>
                                            <div className='col-5 icone-relogio text-right'>
                                                <p className='m-0'><small><i className="fa fa-clock"></i> 4min de leitura</small></p>
                                            </div>
                                        </div>
                                        {/* <div className="div-img-capa" style={{ backgroundImage: `url(${imagem})` }} /> */}
                                        <img className="img img-fluid" src={imagem} alt={'imagem-de-capa'} />
                                        <div className='col-12 py-2 p-0'>
                                            <div className='row no-gutters'>
                                                <div className='col-3 text-left'>
                                                    <p><i className="fas fa-heart text-danger"></i> 15</p>
                                                </div>
                                                <div className='col-3'>
                                                    <p><i className="fa fa-share-alt text-verdeBM"></i> 11</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 corpo-texto'>
                                        <p className="mt-4">{previaTexto}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        );

    }

}